import { Reveal } from "./Reveal";
import { DISHES, IMAGES } from "../../data/site";

export const Gallery = () => {
  // Editorial marquee of dishes (doubled for seamless loop)
  const strip = [...DISHES, ...DISHES];

  return (
    <section id="gallery" className="relative py-28 lg:py-40 overflow-hidden" data-testid="gallery">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <p className="overline mb-5">The Kitchen & The Room</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-[var(--br-cream)] leading-[1.05] max-w-3xl">
            Plates that <span className="italic text-[var(--br-gold)]">carry fire</span>, rooms that hold the night.
          </h2>
        </Reveal>
      </div>

      {/* Dish marquee */}
      <div className="mt-16 overflow-hidden">
        <div className="marquee-track" style={{ animationDuration: "55s" }}>
          {strip.map((d, i) => (
            <figure key={i} className="relative mx-3 w-[300px] shrink-0 overflow-hidden rounded-2xl border border-[var(--br-gold)]/15">
              <img src={d.src} alt="" className="h-[380px] w-full object-cover" />
            </figure>
          ))}
        </div>
      </div>

      {/* Venue photos */}
      <div className="mx-auto max-w-7xl px-6 mt-8 grid gap-4 md:grid-cols-5">
        <Reveal className="md:col-span-3">
          <div className="group relative overflow-hidden rounded-3xl border border-[var(--br-gold)]/15">
            <img src={IMAGES.storefront} alt="Black Rose Lounge storefront at night" className="h-[300px] md:h-[420px] w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <span className="absolute bottom-6 left-6 font-display text-2xl text-[var(--br-cream)]">Falls Church · after dark</span>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="md:col-span-2">
          <div className="group relative overflow-hidden rounded-3xl border border-[var(--br-gold)]/15 h-full">
            <img src={IMAGES.cocktail} alt="Craft cocktails at Black Rose Lounge" className="h-[300px] md:h-[420px] w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <span className="absolute bottom-6 left-6 font-display text-2xl text-[var(--br-cream)]">Craft cocktails</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
